import 'bootstrap/dist/css/bootstrap-utilities.min.css';
import { FAQSection } from '../components/faq';
import HeroSection from '../components/hero/hero-section';
import { RoundedImageCardsSection } from '../components/image-cards';
import AdvantagesSection from '../components/indexpage/advantages-section';
import Layout from '../components/layout/layout';
import { TechnicalClarification } from '../components/technical-clarification';
import TimelineSection from '../components/timeline/timeline-section';
import { TrustPilotSection } from '../components/trust-pilot';
import { Constants } from '../utils/constants';

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <div className="section-wrapper d-flex flex-column">
        <AdvantagesSection />
        <TrustPilotSection title={Constants.MESSAGE.TRUST_PILOT.TITLE} />

        <TechnicalClarification />
        <TimelineSection />
        <RoundedImageCardsSection />
        <FAQSection />
      </div>
    </Layout>
  );
}
